import { Banner } from '@tackle-io/platform-ui';
import { AssignmentIcon } from 'packages/cosell/assets';
import FormSectionCard from '../components/FormSectionCard';
import { FormSectionConfig } from '../constants';
import ControlledSingleSelectField from '../controlledFields/ControlledSingleSelectField';
import ControlledTextField from '../controlledFields/ControlledTextFieldNew';
import useAssistanceRequestCodeOptions from './useAssistanceRequestCodeOptions';
import { fieldConfig, FieldEnum } from './sectionSchema';
import { Box } from 'vendor/material';
import { useReferralFormContext } from '../ReferralFormContext';
import ControlledRadioGroupField from '../controlledFields/ControlledRadioGroupField';

const assistanceRequestCode = fieldConfig[FieldEnum.assistanceRequestCode];
const notes = fieldConfig[FieldEnum.notes];
const consentToShareReferralWithMicrosoftSellers =
  fieldConfig[FieldEnum.consentToShareReferralWithMicrosoftSellers];

export const TypeOfHelpFormSection = () => {
  const assistanceRequestCodeFieldName = assistanceRequestCode.name;
  const options = useAssistanceRequestCodeOptions();
  const { watch } = useReferralFormContext();
  const helpType = watch(assistanceRequestCodeFieldName);

  return (
    <FormSectionCard
      title={FormSectionConfig.typeOfHelp.title}
      subtitle={null}
      icon={<AssignmentIcon />}
      data-id={FormSectionConfig.typeOfHelp.dataId}
      sectionId={FormSectionConfig.typeOfHelp.id}
    >
      <Box sx={{ mb: 2 }}>
        <ControlledSingleSelectField
          name={assistanceRequestCodeFieldName}
          label={assistanceRequestCode.label}
          options={options}
          required={assistanceRequestCode.required}
        />
      </Box>

      {helpType === 'NoHelpNeededFromMicrosoft' ? (
        <NoHelpFromMicrosoftContent />
      ) : (
        <HelpFromMicrosoftContent />
      )}
    </FormSectionCard>
  );
};

export default TypeOfHelpFormSection;

const NoHelpFromMicrosoftContent = () => {
  return (
    <>
      <ControlledRadioGroupField
        dataId="no-help-from-microsoft"
        name={consentToShareReferralWithMicrosoftSellers.name}
        options={[...consentToShareReferralWithMicrosoftSellers.options]}
        label={consentToShareReferralWithMicrosoftSellers.label}
      />
      <Banner
        borderPosition="top"
        isCollapsible
        title={
          'Referral is partner-led. It will be visible only to the Microsoft sales team.'
        }
        body={
          'You can upgrade a partner-led deal to a co-sell with Microsoft at any time prior to being a non-terminal state (won, lost, declined, and expired). Partner-led deals cannot be changed to private once created.'
        }
        type="info"
      />
    </>
  );
};

const HelpFromMicrosoftContent = () => {
  return (
    <>
      <Banner
        borderPosition="top"
        isCollapsible
        title="Notes are AI generated by Microsoft based on customer and solution(s) added. Please make sure they are accurate and edit it as appropriate before sharing."
        type="info"
      />
      <ControlledTextField
        name={notes.name}
        label={notes.label}
        placeholder={notes.placeholder}
        required={notes.required}
        multiline
        rows={5}
      />
    </>
  );
};
